import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Source } from 'src/app/data/models/sources/source';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class SourceService {

  constructor(private http: HttpClient) {   }

  getAllSources(): Observable<Source[]> {
    return this.http.get<Source[]>('/Source/getAllSources');
  }



}


